import { render, staticRenderFns } from "./ProposalOverview.vue?vue&type=template&id=7593d156&"
import script from "./ProposalOverview.vue?vue&type=script&lang=js&"
export * from "./ProposalOverview.vue?vue&type=script&lang=js&"
import style0 from "./ProposalOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports